import UIButton from 'UIComponents/button/UIButton';
import SplitColorSection from './SplitColorSection';
import { H4 } from 'UIComponents/elements/headings';
import UIBox from 'UIComponents/layout/UIBox';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { appendHubsContent } from '../../utils/urls';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SplitSectionContent = ({
  heading,
  description,
  ctaHref,
  ctaMessageKey,
  iconName
}) => {
  return /*#__PURE__*/_jsxs(UIBox, {
    className: "text-center",
    style: {
      maxWidth: '400px'
    },
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: iconName,
      size: 40
    }), /*#__PURE__*/_jsx(H4, {
      children: heading
    }), /*#__PURE__*/_jsx("p", {
      children: description
    }), /*#__PURE__*/_jsx(UIButton, {
      href: appendHubsContent(getProxyUrl(ctaHref), I18n.text(ctaMessageKey)),
      use: "secondary-ghost",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ctaMessageKey
      })
    })]
  });
};
const CoursesAndCertificationsSplitSection = () => {
  return /*#__PURE__*/_jsx(SplitColorSection, {
    leftContent: /*#__PURE__*/_jsx(SplitSectionContent, {
      ctaHref: "/courses",
      ctaMessageKey: "academyPublic.splitSection.leftSideCta",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.splitSection.leftSideDescription"
      }),
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.splitSection.leftSideTitle"
      }),
      iconName: "gauge"
    }),
    rightContent: /*#__PURE__*/_jsx(SplitSectionContent, {
      ctaHref: "/certification-overview",
      ctaMessageKey: "academyPublic.splitSection.rightSideCta",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.splitSection.rightSideDescription"
      }),
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.splitSection.rightSideTitle"
      }),
      iconName: "certification"
    })
  });
};
export default CoursesAndCertificationsSplitSection;